import React  from "react";
import { Box, CircularProgress, Typography, Fade } from "@mui/material";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import logo from "../assests/image/logo.svg"
const SplashScreen: React.FC = () => {
     const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const timer = setTimeout(() => {
      const orderId = searchParams.get("orderId");
      const mode = searchParams.get("mode") || "driver_to_chef";

      if (orderId) {
        navigate(`/track/${orderId}?mode=${mode}`);
        window.location.reload();
      } else {
        console.error(" orderId not provided in URL");
      }
    }, 3000); // 5 seconds splash

    return () => clearTimeout(timer);
  }, [navigate, searchParams]);
  
  return (
    <Fade in timeout={800}>
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "background.paper",
        }}
      >
         
 
  <Box
  component="img"
  src={logo}
  alt="Logo"
  sx={{
    width: 100,       
    height: 100,    
    borderRadius: 2,   
    objectFit: "contain", 
  }}
/>
        
        <Typography variant="h3" fontWeight="bold" gutterBottom>
          Frayo Order Tracking
        </Typography>

        <CircularProgress size={60} thickness={4} />

        <Typography variant="subtitle1" sx={{ mt: 2 }}>
          Loading order details....
        </Typography>
      </Box>
    </Fade>
  );
};

export default SplashScreen;
